import React from "react";
import RichText from "./RichText";

function Viewer(props) {
  return <RichText readOnly value={props.content} {...props} />;
}

export default Viewer;
